import { useEffect } from "react";

const BASE = "Lansdowne Youth Rugby - Youth Rugby Club in New York";

export function usePageTitle(title, description) {
  useEffect(() => {
    document.title = title || BASE;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute("name", "description");
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    return () => { document.title = BASE; };
  }, [title, description]);
}
